export interface RbacUser {
  role?: string
  status?: string
  ev_role?: string
  ev_status?: string
  golf_role?: string
  golf_status?: string
}

export enum RbacAction {
  READ = 'read',
  UPDATE = 'update',
  CREATE = 'create',
}

export enum RbacEntity {
  USERS = 'users',
  CARS = 'carProfiles',
  CARS_EV = 'evCarProfiles',
  CARS_GOLF = 'golfCarProfiles',
  APP_SETTINGS = 'appSettings',
  TRIPS = 'trips',
  ADMIN_PROFILES = 'adminProfiles',
  LOGS = 'logs',
  WALLET = 'wallet',
  USER_HOST_SECTION = 'userHostSection',
  MANUAL_FINANCIAL_OPERATIONS = 'manualFinancialOperations',
  INSURANCE_VEHICLE = 'insuranceVehicle',
  INSURANCE_USER = 'insuranceUser',
  EV_OWNER_STATISTICS = 'evOwnerStatistics',
}

export const getScope = (action: RbacAction, entity: RbacEntity): string => {
  return `${action}_${entity}`
}

export const getReadScopes = (entities: RbacEntity[]): string[] => {
  return entities.map(e => getScope(RbacAction.READ, e))
}

export const hasP2pAccess = (user?: RbacUser | null): boolean => {
  if (!user) return false
  if (user.role === 'super_admin' || user.role === 'admin') return true
  return Boolean(user.role && user.status !== 'blocked')
}

export const hasEvAccess = (user?: RbacUser | null): boolean => {
  if (!user) return false
  if (user.role === 'super_admin') return true
  return Boolean(user.ev_role && user.ev_status !== 'blocked')
}

export const hasGolfAccess = (user?: RbacUser | null): boolean => {
  if (!user) return false
  if (user.role === 'super_admin') return true
  return Boolean(user.golf_role && user.golf_status !== 'blocked')
}
